(function () {
  if (window.__spKrFit) return;
  window.__spKrFit = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia && matchMedia('(min-width: 1100px)');
  var PROXY = /\/width:(\d+)\//;
  var STEP = 320;
  var MAX_W = 2400;
  var rootStyle = getComputedStyle(document.documentElement);
  function tok(name, fallback) { return (rootStyle.getPropertyValue(name) || '').trim() || fallback; }
  function ms(v) { var n = parseFloat(v); return /ms$/.test(v) ? n : n * 1000; }
  var DUR_ENTER = ms(tok('--sp-dur-3', '320ms'));
  var DUR_TRAVEL = ms(tok('--sp-dur-4', '420ms'));
  var EASE_OUT = tok('--sp-ease-out', 'cubic-bezier(0.22, 1, 0.36, 1)');
  var DUR_FEEDBACK = ms(tok('--sp-dur-1', '160ms'));
  var STAGGER = Math.round(DUR_FEEDBACK / 3);

  function sharpen(bg) {
    var slides = bg.querySelectorAll('.kl_reviews__lightbox__left .swiper-slide-active, .kl_reviews__lightbox__left .swiper-slide-next');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('.kl_reviews__gallery_lightbox_thumbnail_container img');
      if (!img) continue;
      var src = img.getAttribute('src') || '';
      var m = src.match(PROXY);
      if (!m) continue;
      var box = img.getBoundingClientRect();
      if (!box.width || !box.height) continue;
      var drawn = img.naturalWidth && img.naturalHeight ? Math.min(box.width, box.height * img.naturalWidth / img.naturalHeight) : box.width;
      var want = Math.min(MAX_W, Math.ceil(drawn * (window.devicePixelRatio || 1) / STEP) * STEP);
      if (want <= Number(m[1]) || (img.__spKrWant || 0) >= want) continue;
      img.__spKrWant = want;
      swapWhenReady(img, src, src.replace(PROXY, '/width:' + want + '/'));
    }
  }
  var FILL_CROP = 1.18;
  function fill(bg) {
    var slides = bg.querySelectorAll('.kl_reviews__lightbox__left .swiper-slide-active, .kl_reviews__lightbox__left .swiper-slide-next, .kl_reviews__lightbox__left .swiper-slide-prev');
    var d = Math.min(window.devicePixelRatio || 1, 2);
    for (var i = 0; i < slides.length; i++) {
      var sl = slides[i];
      var img = sl.querySelector('.kl_reviews__gallery_lightbox_thumbnail_container img');
      if (!img || img.hasAttribute('data-sp-kr-rotated')) continue;
      var nw = img.naturalWidth, nh = img.naturalHeight, W = sl.clientWidth, H = sl.clientHeight;
      if (!nw || !nh || !W || !H) continue;
      var c = Math.min(W / nw, H / nh), cover = Math.max(W / nw, H / nh) / c;
      var f = cover <= FILL_CROP ? cover : 1;
      var m = (img.getAttribute('src') || '').match(PROXY);
      if (m && nw < Number(m[1])) f = Math.min(f, nw / (nw * c * d));
      var on = f > 1.01;
      if (on) {
        var w = (nw * c * f).toFixed(1) + 'px', h = (nh * c * f).toFixed(1) + 'px';
        if (img.style.getPropertyValue('--sp-kr-fill-w') !== w) img.style.setProperty('--sp-kr-fill-w', w);
        if (img.style.getPropertyValue('--sp-kr-fill-h') !== h) img.style.setProperty('--sp-kr-fill-h', h);
        if (!img.hasAttribute('data-sp-kr-fill')) img.setAttribute('data-sp-kr-fill', '');
      } else if (img.hasAttribute('data-sp-kr-fill')) {
        img.removeAttribute('data-sp-kr-fill');
      }
    }
  }

  function swapWhenReady(img, from, to) {
    var pre = new Image();
    var done = function () { if (img.getAttribute('src') === from) img.setAttribute('src', to); };
    pre.src = to;
    if (pre.decode) pre.decode().then(done, function () {});
    else pre.onload = done;
  }
  function unclass(el, c) {
    if (el.classList.contains(c)) el.classList.remove(c);
  }

  function more(bg) {
    var right = bg.querySelector('.kl_reviews__lightbox__right');
    if (!right) return;
    var p = right.querySelector(':scope > p');
    var btn = right.querySelector(':scope > .sp-kr-more');
    if (!p) {
      if (btn) btn.remove();
      unclass(bg, 'sp-kr-lb-clamped');
      unclass(bg, 'sp-kr-lb-expanded');
      return;
    }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sp-kr-more';
      btn.innerHTML = '<span class="sp-kr-more__label">Read more</span>';
      right.appendChild(btn);
    }
    var open = bg.classList.contains('sp-kr-lb-expanded');
    var clamped = !(wide && wide.matches) && (open || p.scrollHeight > p.clientHeight + 1);
    bg.classList.toggle('sp-kr-lb-clamped', clamped);
    var label = open ? 'Show less' : 'Read more';
    if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
    if (btn.getAttribute('aria-expanded') !== String(open)) btn.setAttribute('aria-expanded', String(open));
  }
  var PREF_KEY = 'sp-kr-readmore';
  function prefOpen() {
    try { return window.localStorage.getItem(PREF_KEY) === 'open'; } catch (e) { return false; }
  }
  function savePref(open) {
    try { window.localStorage.setItem(PREF_KEY, open ? 'open' : 'closed'); } catch (e) {}
  }

  function setFull(bg) {
    var p = bg.querySelector('.kl_reviews__lightbox__right > p');
    if (!p) return;
    var full = p.scrollHeight;
    bg.style.setProperty('--sp-kr-p-full', full + 'px');
  }

  var THUMB_W = 160;

  function mediaList(bg) {
    var main = bg.querySelectorAll('.kl_reviews__lightbox__left .swiper-slide');
    var pager = bg.querySelectorAll('.kl_reviews__lightbox__image_list .swiper-slide');
    var list = [];
    var group = -1;
    var lastKey = null;
    for (var i = 0; i < main.length; i++) {
      var t = pager[i] && pager[i].querySelector('img');
      var own = main[i].querySelector('.kl_reviews__gallery_lightbox_thumbnail_container img');
      var src = (t && t.getAttribute('src')) || (own && own.getAttribute('src')) || '';
      var key = (t && t.getAttribute('alt')) || (own && own.getAttribute('alt')) || '';
      if (key !== lastKey) { group++; lastKey = key; }
      var media = main[i].querySelector('video') || main[i].querySelector('img');
      var turn = media && typeof window.spKrRotationFor === 'function' ? window.spKrRotationFor(media) : 0;
      list.push({
        i: i,
        rot: turn,
        src: thumbUrl(src),
        video: !!main[i].querySelector('video') || !!(pager[i] && pager[i].querySelector('.kl_reviews__gallery_lightbox_thumbnail_video_indicator')),
        group: group
      });
    }
    return list;
  }
  function thumbUrl(src) {
    if (!/\/plain\//.test(src)) return src;
    return src.replace(/\/(?:width|height|resizing_type):[^/]+/g, '').replace(/\/plain\//, '/width:' + THUMB_W + '/plain/');
  }
  function thumbButton(m, n, total, defer) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sp-kr-thumb' + (m.video ? ' sp-kr-thumb--video' : '');
    b.setAttribute('data-sp-kr-i', String(m.i));
    b.setAttribute('aria-label', (m.video ? 'Video ' : 'Photo ') + n + ' of ' + total);
    var img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    b.setAttribute('data-sp-kr-where', defer ? 'strip' : 'row');
    if (m.src) img.setAttribute(defer ? 'data-src' : 'src', m.src);
    if (m.rot) img.style.rotate = m.rot + 'deg';
    if (!defer) loadIn(img);
    b.appendChild(img);
    if (typeof window.spThumbCrop === 'function') window.spThumbCrop(b, img);
    return b;
  }
  var LOADED = {};

  function reveal(img) {
    var src = img.getAttribute('data-src');
    if (!src) return;
    img.removeAttribute('data-src');
    img.loading = 'eager';
    img.setAttribute('src', src);
    loadIn(img);
  }

  function lazyStrip(strip) {
    var imgs = strip.querySelectorAll('img[data-src]');
    if (!('IntersectionObserver' in window)) { for (var i = 0; i < imgs.length; i++) reveal(imgs[i]); return; }
    var io = new IntersectionObserver(function (es) {
      for (var k = 0; k < es.length; k++) {
        if (!es[k].isIntersecting) continue;
        io.unobserve(es[k].target);
        reveal(es[k].target);
      }
    }, { root: strip, rootMargin: '0px 50%' });
    for (var j = 0; j < imgs.length; j++) io.observe(imgs[j]);
  }

  function loadIn(img) {
    var src = img.getAttribute('src');
    if ((img.complete && img.naturalWidth) || LOADED[src]) { img.classList.add('is-loaded'); return; }
    img.classList.add('sp-kr-fade');
    img.addEventListener('load', function () {
      if (!img.naturalWidth) return;
      LOADED[src] = true;
      img.classList.add('is-loaded');
    }, { once: true });
  }
  var PH = 'sp-kr-ph';

  function phBox(slide, ratio) {
    var w = slide.clientWidth;
    var h = slide.clientHeight;
    if (!w || !h) return null;
    var k = Math.min(w / ratio, h);
    return { w: Math.round(k * ratio), h: Math.round(k) };
  }

  function thumbFor(bg, i) {
    var t = bg.querySelector('.sp-kr-strip .sp-kr-thumb[data-sp-kr-i="' + i + '"] img');
    return t && t.complete && t.naturalWidth ? t : null;
  }

  function settle(slide, img) {
    img.__spKrSharp = true;
    if (!img.hasAttribute('data-sp-kr-wait')) return;
    img.removeAttribute('data-sp-kr-wait');
    var ph = slide.querySelector(':scope > .' + PH);
    if (!ph) return;
    setTimeout(function () { if (ph.parentNode) ph.remove(); }, reduce && reduce.matches ? 0 : DUR_ENTER + 40);
  }

  function hook(slide, img) {
    if (img.__spKrHook) return;
    img.__spKrHook = true;
    img.addEventListener('load', function () { if (img.naturalWidth) settle(slide, img); });
    img.addEventListener('error', function () {
      var ph = slide.querySelector(':scope > .' + PH);
      if (ph) { var c = ph.querySelector('canvas'); if (c) c.remove(); ph.classList.remove('is-blur'); ph.classList.add('is-failed'); }
    });
  }

  function placeholders(bg) {
    var slides = bg.querySelectorAll('.kl_reviews__lightbox__left .swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      if (!slide.classList.contains('swiper-slide-active') && !slide.classList.contains('swiper-slide-next') && !slide.querySelector(':scope > .' + PH)) continue;
      var img = slide.querySelector('.kl_reviews__gallery_lightbox_thumbnail_container img');
      if (!img || img.hasAttribute('data-sp-kr-rotated')) continue;
      hook(slide, img);
      if (img.complete && img.naturalWidth) { settle(slide, img); continue; }
      if (img.__spKrSharp) continue;
      if (!img.hasAttribute('data-sp-kr-wait')) img.setAttribute('data-sp-kr-wait', '');
      var thumb = thumbFor(bg, i);
      if (!thumb) {
        var st = bg.querySelector('.sp-kr-strip .sp-kr-thumb[data-sp-kr-i="' + i + '"] img[data-src]');
        if (st) { try { st.fetchPriority = 'high'; } catch (e) {} reveal(st); }
      }
      var ph = slide.querySelector(':scope > .' + PH);
      if (!ph) {
        ph = document.createElement('div');
        ph.className = PH;
        ph.setAttribute('aria-hidden', 'true');
        slide.appendChild(ph);
      }
      var box = thumb ? phBox(slide, thumb.naturalWidth / thumb.naturalHeight) : { w: slide.clientWidth, h: slide.clientHeight };
      if (box) {
        var w = box.w + 'px';
        var h = box.h + 'px';
        if (ph.style.width !== w) ph.style.width = w;
        if (ph.style.height !== h) ph.style.height = h;
      }
      if (thumb && !ph.classList.contains('is-failed') && ph.__spKrThumb !== thumb.currentSrc) {
        var c = ph.querySelector('canvas') || ph.appendChild(document.createElement('canvas'));
        c.width = thumb.naturalWidth;
        c.height = thumb.naturalHeight;
        try { c.getContext('2d').drawImage(thumb, 0, 0); ph.__spKrThumb = thumb.currentSrc; ph.classList.add('is-blur'); } catch (err) {}
      }
    }
  }

  function goTo(bg, i) {
    var sw = bg.querySelector('.kl_reviews__lightbox__left .swiper');
    if (sw && sw.swiper) { sw.swiper.slideTo(i, Math.abs(i - sw.swiper.activeIndex) > 1 ? 0 : undefined); return; }
    var pager = bg.querySelectorAll('.kl_reviews__lightbox__image_list .swiper-slide');
    if (pager[i]) pager[i].click();
  }

  function onThumbClick(bg) {
    return function (e) {
      e.stopPropagation();
      var b = e.target.closest && e.target.closest('.sp-kr-thumb');
      if (!b) return;
      var grp = b.closest('.sp-kr-strip__group.is-stack');
      if (grp && b.classList.contains('is-active')) {
        var items = grp.querySelectorAll('.sp-kr-thumb');
        for (var q = 0; q < items.length; q++) {
          if (items[q] === b) { b = items[(q + 1) % items.length]; break; }
        }
      }
      goTo(bg, Number(b.getAttribute('data-sp-kr-i')));
    };
  }

  function buildStrip(bg, list) {
    var strip = document.createElement('div');
    strip.className = 'sp-kr-strip';
    strip.setAttribute('role', 'group');
    strip.setAttribute('aria-label', 'All review photos and videos');
    var track = document.createElement('div');
    track.className = 'sp-kr-strip__track';
    var g = null;
    for (var i = 0; i < list.length; i++) {
      if (!g || list[i].group !== list[i - 1].group) {
        g = document.createElement('div');
        g.className = 'sp-kr-strip__group';
        track.appendChild(g);
      }
      g.appendChild(thumbButton(list[i], i + 1, list.length, true));
    }
    strip.appendChild(track);
    strip.addEventListener('click', onThumbClick(bg));
    strip.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX) || strip.scrollWidth <= strip.clientWidth) return;
      e.preventDefault();
      cancelGlide(strip);
      strip.scrollLeft += e.deltaY;
    }, { passive: false });
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      strip.addEventListener(ev, function () { cancelGlide(strip); }, { passive: true });
    });
    bg.appendChild(strip);
    lazyStrip(strip);
    return strip;
  }

  function cancelGlide(el) {
    if (el.__spKrGlide) cancelAnimationFrame(el.__spKrGlide);
    el.__spKrGlide = 0;
  }
  function glide(strip, thumb, instant) {
    var tr = thumb.getBoundingClientRect();
    var sr = strip.getBoundingClientRect();
    var target = strip.scrollLeft + (tr.left + tr.width / 2) - (sr.left + strip.clientWidth / 2);
    target = Math.max(0, Math.min(target, strip.scrollWidth - strip.clientWidth));
    cancelGlide(strip);
    var from = strip.scrollLeft;
    if (instant || (reduce && reduce.matches) || Math.abs(target - from) < 1) { strip.scrollLeft = target; return; }
    var t0 = null;
    var step = function (now) {
      if (t0 === null) t0 = now;
      var k = Math.min(1, (now - t0) / DUR_TRAVEL);
      var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      strip.scrollLeft = from + (target - from) * e;
      strip.__spKrGlide = k < 1 ? requestAnimationFrame(step) : 0;
    };
    strip.__spKrGlide = requestAnimationFrame(step);
  }

  function activeIndex(bg) {
    var main = bg.querySelectorAll('.kl_reviews__lightbox__left .swiper-slide');
    for (var i = 0; i < main.length; i++) if (main[i].classList.contains('swiper-slide-active')) return i;
    return -1;
  }

  function mark(scope, i) {
    var bs = scope.querySelectorAll('.sp-kr-thumb');
    var hit = null;
    for (var k = 0; k < bs.length; k++) {
      var on = bs[k].getAttribute('data-sp-kr-i') === String(i);
      if (on) hit = bs[k];
      if (on && bs[k].getAttribute('aria-current') !== 'true') bs[k].setAttribute('aria-current', 'true');
      if (!on && bs[k].hasAttribute('aria-current')) bs[k].removeAttribute('aria-current');
      bs[k].classList.toggle('is-active', on);
    }
    return hit;
  }
  function stack(strip, i) {
    var groups = strip.querySelectorAll('.sp-kr-strip__group');
    for (var gI = 0; gI < groups.length; gI++) {
      var items = groups[gI].querySelectorAll('.sp-kr-thumb');
      var multi = items.length > 1;
      if (groups[gI].classList.contains('is-stack') !== multi) groups[gI].classList.toggle('is-stack', multi);
      if (!multi) continue;
      var cover = 0;
      for (var k = 0; k < items.length; k++) if (items[k].getAttribute('data-sp-kr-i') === String(i)) cover = k;
      for (var k2 = 0; k2 < items.length; k2++) {
        var layer = String((k2 - cover + items.length) % items.length);
        if (items[k2].getAttribute('data-layer') !== layer) items[k2].setAttribute('data-layer', layer);
        var under = layer !== '0';
        if (under !== (items[k2].tabIndex === -1)) items[k2].tabIndex = under ? -1 : 0;
        if (under) items[k2].setAttribute('aria-hidden', 'true'); else items[k2].removeAttribute('aria-hidden');
      }
    }
  }

  function thumbs(bg) {
    var count = bg.querySelectorAll('.kl_reviews__lightbox__left .swiper-slide').length;
    if (!count) return;
    if (!bg.__spKrMedia || bg.__spKrMedia.length !== count) {
      bg.__spKrMedia = mediaList(bg);
      var old = bg.querySelector(':scope > .sp-kr-strip');
      if (old) old.remove();
      bg.__spKrActive = -1;
    }
    var list = bg.__spKrMedia;
    var strip = bg.querySelector(':scope > .sp-kr-strip') || buildStrip(bg, list);
    var i = activeIndex(bg);
    if (i < 0) return;
    var hit = mark(strip, i);
    stack(strip, i);
    if (hit && i !== bg.__spKrActive) {
      glide(strip, hit, bg.__spKrActive === -1);
      bg.__spKrActive = i;
    }
    var right = bg.querySelector('.kl_reviews__lightbox__right');
    if (!right) return;
    var row = right.querySelector(':scope > .sp-kr-rthumbs');
    var g = list[i].group;
    var mine = list.filter(function (m) { return m.group === g; });
    if (!row) {
      row = document.createElement('div');
      row.className = 'sp-kr-rthumbs';
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', 'Photos and videos in this review');
      row.addEventListener('click', onThumbClick(bg));
    }
    if (right.lastElementChild !== row) right.appendChild(row);
    if (row.getAttribute('data-sp-kr-g') !== String(g)) {
      row.setAttribute('data-sp-kr-g', String(g));
      var olds = row.querySelectorAll(':scope > .sp-kr-thumb');
      for (var o = 0; o < olds.length; o++) olds[o].remove();
      for (var k = 0; k < mine.length; k++) {
        var tb = thumbButton(mine[k], k + 1, mine.length);
        if (k >= 12) tb.classList.add('is-over');
        if (k === 11 && mine.length > 12) {
          var more = document.createElement('span');
          more.className = 'sp-kr-rthumbs__more';
          more.setAttribute('aria-hidden', 'true');
          more.textContent = '+' + (mine.length - 12);
          tb.appendChild(more);
        }
        row.appendChild(tb);
      }
      row.setAttribute('data-n', String(mine.length));
    }
    var single = mine.length < 2 && !(wide && wide.matches);
    if (row.hidden !== single) row.hidden = single;
    var rowHit = mark(row, i);
    if (rowHit && i !== bg.__spKrRowActive && row.scrollWidth > row.clientWidth) {
      glide(row, rowHit, bg.__spKrRowGroup !== g);
    }
    bg.__spKrRowActive = i;
    bg.__spKrRowGroup = g;
  }
  var NEAR = 12;
  var DRAG = 8;

  function inRect(r, x, y, pad) {
    pad = pad || 0;
    return x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad;
  }

  function drawnBox(media) {
    var r = media.getBoundingClientRect();
    var nw = media.tagName === 'VIDEO' ? media.videoWidth : media.naturalWidth;
    var nh = media.tagName === 'VIDEO' ? media.videoHeight : media.naturalHeight;
    if (!nw || !nh) return r;
    var deg = Number(media.getAttribute('data-sp-kr-rotated') || 0);
    var quarter = deg % 180 !== 0;
    var bw = quarter ? media.offsetHeight : media.offsetWidth;
    var bh = quarter ? media.offsetWidth : media.offsetHeight;
    if (!bw || !bh) { bw = r.width; bh = r.height; }
    var k = Math.min(bw / (quarter ? nh : nw), bh / (quarter ? nw : nh));
    var w = (quarter ? nh : nw) * k;
    var h = (quarter ? nw : nh) * k;
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    return { left: cx - w / 2, right: cx + w / 2, top: cy - h / 2, bottom: cy + h / 2 };
  }

  function closesOnClick(bg, e, down) {
    var t = e.target;
    if (!e.detail || !t || !t.closest || !t.closest('.kl_reviews__lightbox__left')) return false;
    if (t.closest('.sp-kr-vbar, a, input, select, textarea') || (t.closest('button') && !t.closest('.sp-kr-vplay'))) return false;
    var x = e.clientX;
    var y = e.clientY;
    if (down && Math.abs(x - down.x) + Math.abs(y - down.y) > DRAG) return false;
    var sw = bg.querySelector('.kl_reviews__lightbox__left .swiper');
    if (sw && sw.swiper && sw.swiper.allowClick === false) return false;
    var guard = bg.querySelectorAll('.kl_reviews__close_button, .kl_reviews__lightbox__image_list > button, .sp-kr-strip');
    for (var i = 0; i < guard.length; i++) {
      if (inRect(guard[i].getBoundingClientRect(), x, y, guard[i].classList.contains('sp-kr-strip') ? 0 : NEAR)) return false;
    }
    var media = bg.querySelector('.kl_reviews__lightbox__left .swiper-slide-active video, .kl_reviews__lightbox__left .swiper-slide-active .kl_reviews__gallery_lightbox_thumbnail_container img');
    if (media) {
      var db = drawnBox(media);
      var sl = media.hasAttribute('data-sp-kr-fill') && media.closest('.swiper-slide');
      if (sl) {
        var sr = sl.getBoundingClientRect();
        db = { left: Math.max(db.left, sr.left), top: Math.max(db.top, sr.top), right: Math.min(db.right, sr.right), bottom: Math.min(db.bottom, sr.bottom) };
      }
      if (inRect(db, x, y)) return false;
    }
    return true;
  }
  function fadeText(right) {
    if (!right || !right.animate) return;
    var parts = Array.prototype.filter.call(right.children, function (el) { return el.getClientRects().length; });
    parts.concat(right).forEach(function (el) { el.getAnimations().forEach(function (a) { a.cancel(); }); });
    if (reduce && reduce.matches) {
      right.animate([{ opacity: 0 }, { opacity: 1 }], { duration: DUR_FEEDBACK, easing: EASE_OUT });
      return;
    }
    for (var i = 0; i < parts.length; i++) {
      parts[i].animate(
        [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }],
        { duration: DUR_ENTER, easing: EASE_OUT, delay: Math.min(i, 4) * STAGGER, fill: 'backwards' }
      );
    }
  }

  function watch(bg) {
    if (bg.__spKrFit) return;
    bg.__spKrFit = true;
    var lastText = null;
    var run = function () {
      var right = bg.querySelector('.kl_reviews__lightbox__right');
      var p = right && right.querySelector(':scope > p');
      var txt = p ? p.textContent : '';
      if (txt !== lastText) {
        if (lastText !== null) fadeText(right);
        if (p && prefOpen()) {
          setFull(bg);
          if (!bg.classList.contains('sp-kr-lb-expanded')) bg.classList.add('sp-kr-lb-expanded');
        } else {
          unclass(bg, 'sp-kr-lb-expanded');
        }
        lastText = txt;
      }
      more(bg);
      thumbs(bg);
      placeholders(bg);
      fill(bg);
      sharpen(bg);
    };
    bg.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var onBtn = e.target.closest('.sp-kr-more');
      if (!onBtn) {
        if (!bg.classList.contains('sp-kr-lb-clamped')) return;
        if (!e.target.closest('.kl_reviews__lightbox__right')) return;
        if (e.target.closest('a, button, input, .sp-kr-rthumbs')) return;
        var sel = window.getSelection && window.getSelection();
        if (sel && !sel.isCollapsed) return;
      }
      setFull(bg);
      savePref(bg.classList.toggle('sp-kr-lb-expanded'));
      more(bg);
    });
    bg.addEventListener('load', function () { fill(bg); sharpen(bg); }, true);
    var down = null;
    bg.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, true);
    var foldTap = function (e) {
      if (!bg.isConnected) { window.removeEventListener('click', foldTap, true); return; }
      if (!bg.classList.contains('sp-kr-lb-expanded') || !e.target.closest || !bg.contains(e.target)) return;
      if (!e.target.closest('.kl_reviews__lightbox__left')) return;
      if (e.target.closest('a, button, input, .sp-kr-strip, .sp-kr-zoom-btn, .kl_reviews__lightbox__image_list')) return;
      if (down && Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 8) return;
      e.preventDefault();
      e.stopPropagation();
      unclass(bg, 'sp-kr-lb-expanded');
      savePref(false);
      more(bg);
    };
    window.addEventListener('click', foldTap, true);
    bg.addEventListener('click', function (e) {
      if (!closesOnClick(bg, e, down)) return;
      e.preventDefault();
      e.stopPropagation();
      var x = bg.querySelector('.kl_reviews__close_button');
      if (x) x.click();
    }, true);
    var queued = false;
    var schedule = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    };
    new MutationObserver(schedule).observe(bg, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', function () {
      if (!bg.isConnected) return;
      if (bg.classList.contains('sp-kr-lb-expanded')) setFull(bg);
      run();
    });
    run();
  }
  var current = null;
  var opener = null;
  var trigger = null;
  var FOCUSABLE = 'button, a[href], input, select, textarea, video[controls], [tabindex]:not([tabindex="-1"])';

  function noteTrigger(e) {
    if (current && current.isConnected) return;
    var t = e.target && e.target.closest && e.target.closest('[role="button"], button, a[href], [tabindex]');
    if (t) trigger = t;
  }
  document.addEventListener('pointerdown', noteTrigger, true);
  document.addEventListener('click', noteTrigger, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') noteTrigger(e); }, true);

  function focusables(bg) {
    return Array.prototype.filter.call(bg.querySelectorAll(FOCUSABLE), function (el) {
      return el.tabIndex >= 0 && !el.disabled && !el.hidden && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    });
  }
  var lastIn = null;
  var lastKey = null;
  function keyOf(el) {
    return { c: (el.classList && el.classList[0]) || '', i: el.getAttribute('data-sp-kr-i'), strip: !!el.closest('.sp-kr-strip') };
  }
  function restore() {
    if (!current || !current.isConnected) return;
    var f = focusables(current);
    var k = lastKey;
    var twin = null;
    if (k) {
      for (var n = 0; n < f.length && !twin; n++) {
        if (f[n].classList[0] === k.c && f[n].getAttribute('data-sp-kr-i') === k.i && !!f[n].closest('.sp-kr-strip') === k.strip) twin = f[n];
      }
    }
    var to = twin || f[0] || current;
    try { to.focus({ preventScroll: true }); } catch (err) { to.focus(); }
  }
  function lost() {
    var a = document.activeElement;
    return !a || a === document.body || a === document.documentElement;
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !current || !current.isConnected) return;
    var f = focusables(current);
    var a = document.activeElement;
    if (!f.length) { e.preventDefault(); current.focus(); return; }
    var first = f[0];
    var last = f[f.length - 1];
    if (!current.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && (a === first || a === current)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    else {
      var back = e.shiftKey;
      setTimeout(function () {
        if (!current || !current.isConnected || current.contains(document.activeElement)) return;
        var g = focusables(current);
        var to = (back ? g[g.length - 1] : g[0]) || current;
        try { to.focus({ preventScroll: true }); } catch (err) { to.focus(); }
      }, 0);
    }
  }, true);
  document.addEventListener('focusin', function (e) {
    if (!current || !current.isConnected) return;
    if (current.contains(e.target)) {
      if (e.target !== current) { lastIn = e.target; lastKey = keyOf(e.target); }
      return;
    }
    var f = focusables(current);
    (f[0] || current).focus();
  });

  function opened(bg) {
    current = bg;
    lastIn = null;
    lastKey = null;
    opener = trigger && trigger.isConnected && !bg.contains(trigger) ? trigger : null;
  }
  function closed() {
    var o = opener;
    current = null;
    opener = null;
    trigger = null;
    lastIn = null;
    lastKey = null;
    if (!o || !o.isConnected) return;
    requestAnimationFrame(function () {
      var a = document.activeElement;
      if (a && a.matches && a.matches('input, textarea, select, [contenteditable="true"]')) return;
      try { o.focus({ preventScroll: true }); } catch (err) { o.focus(); }
    });
  }
  new MutationObserver(function (list) {
    var added = false;
    for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length) { added = true; break; }
    if (current && !current.isConnected) closed();
    if (current && lastIn && !lastIn.isConnected && lost()) {
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (lost()) restore(); }); });
    }
    if (!added) return;
    var bg = document.querySelector('.kl_reviews__lightbox_background');
    if (bg && bg !== current) { opened(bg); watch(bg); }
  }).observe(document.body, { childList: true, subtree: true });
})();
